import { Moment } from "moment";
import { ColdStateType } from "../pages/DecisionHub/interfaces";

export interface Company {
  id: number;
  name: string;
}

export interface Report {
  id: number;
  name: string;
  initialReportName?: string;
  companyName?: string;
  companies?: string[];
  createdByUserId: number;
  createTime: number;
  status: ReportStatus;
  emailSubject: string;
  emailBody: string;
  workspaceId: string;
  ipName?: string;
  dataSource?: string[];
  defaultDataPeriod?: any;
  accessTokenIds?: string[];
  dataPeriodArr?: string[];
  versionDataPeriod?: DataPeriodType;
  updateTime?: Date;
  dataPeriod?: any;
  companyId?: number;
}

export enum WorkspaceStatus {
  exist = "ALREADY_EXIST",
  defaultWs = "DEFAULT_WORKSPACE",
  tempWs = "TEMP_WORKSPACE",
  insufficientConnections = "INSUFFICIENT_CONNECTIONS",
  inQueue = "SENT_IN_QUEUE",
  creating = "SENT_FOR_CREATION",
  error = "ERROR",
}
export interface ReportVersion {
  id: number;
  accessTokenIds?: string[];
  reportId: number;
  updateTime: number;
  templateExcelUserFileId: string;
  parentVersion: number;
  isConsolidated?: boolean;
  versionDataPeriod?: DataPeriodType;
  dataSource?: string;
}

export interface ReportVersionWithName {
  id: number;
  accessTokenIds?: number[];
  reportId: number;
  updateTime: number;
  templateExcelUserFileId: string;
  parentVersion: number;
  createdBy: number;
  reportName?: string;
  dataPeriod?: any;
  isConsolidated?: boolean;
  versionDataPeriod?: DataPeriodType;
  dataPeriodArr?: string[];
  initialReportName?: string;
  dataSource?: string[];
}

export enum ReportStatus {
  Active = "Active",
  Draft = "Draft",
  InActive = "InActive",
}

export let chartTypes = [
  "pie",
  "bar",
  "pie3d",
  "doughnut",
  "line",
  "col",
  "col3d",
  "bar stacked",
  "bar 100 per stacked",
  "col stacked",
  "col 100 per stacked",
  "line 100 per stacked",
  "line stacked with markers",
  "line with markers",
  "line stacked",
  "histogram",
  "scatter",
];
export interface Chart {
  id: number;
  reportVersionId: number;
  type:
    | "pie"
    | "bar"
    | "pie3d"
    | "doughnut"
    | "line"
    | "col"
    | "col3d"
    | "bar stacked"
    | "bar 100 per stacked"
    | "col stacked"
    | "col 100 per stacked"
    | "line 100 per stacked"
    | "line stacked with markers"
    | "line stacked"
    | "line with markers"
    | "histogram"
    | "scatter";

  title: string;
  valueUnit?: string;
  companyName?: string;
  showOnWhatsapp: boolean;
  showOnEmail: boolean;
  onUserDashboard: string[];
  pinUserDashboard: string[];
  hasNoAccess: string[];
  label: string[];
  datasets: { data: string[] | number[]; label: string }[];
  config: {
    category?: {};
    xAxisLabel?: string;
    yAxisLabel?: string;
    timePeriod?: string;
    y1AxisLabel?: string;
    dataAlertLabel?: string;
    dualAxis?: boolean;
    units?: string[];
    formula?: string;
    dualForAll?: Boolean;
    xDate?: Boolean;
    showTotal?: boolean;
    isOAEUsed?: boolean;
    data_source?: [];
  };
  chartIdentifier?: string;
  order?: string;
  // points: { key: string; value: string | number }[];
  createTime: number;
  reportId?: number;
  reportName?: string;
  updatedAt?: number;
  overview?: string;
  action?: string;
  ipName?: string;
  dpType?: any;
}
export interface PieChart extends Chart {}
export interface BarChart extends Chart {}
export interface LineChart extends Chart {}
export interface DoughnutChart extends Chart {}
export interface ScatterChart extends Chart {}

export interface Cohort {
  id: number;
  title: string;
  reportVersionId: number;
  header: string[][];
  companyName?: string;
  companyId?: number;
  body: { parent: string[]; child: string | number }[];
  config?: {
    connect: Array<string>;
    timePeriod?: string;
    data_source?: Array<string>;
    formula?: string;
    isOAEUsed?: boolean;
    tableInfo?: string;
    showOnlyTimeString?: boolean;
  };
  footer: string[];
  cohortIdentifier?: string;
  order?: string;
  reportId?: number;
  reportName?: string;
  createTime: number;
  updatedAt?: number;
  overview?: string;
  action?: string;
  ipName?: string;
  dpType?: any;
}

export interface PivotTable {
  id: number;
  name: string;
  reportVersionId: number;
  header: string[][];
  companyName?: string;
  companyId?: number;
  body: { parent: string[]; child: string | number }[];
  config?: {
    category?: {};
    xAxisLabel?: {};
    yAxisLabel?: {};
    timePeriod?: any;
    formula?: string;
    topHeader?: {
      col: any;
      name: any;
    }[];
    innerFooterInRow?: boolean;
    data_source?: {};
    isOAEUsed: boolean;
    tableInfo?: string;
    showOnlyTimeString?: boolean;
  };
  footer: string[];
  showOnWhatsapp?: boolean;
  showOnEmail?: boolean;
  onUserDashboard: string[];
  pinUserDashboard: string[];
  pivotIdentifier?: string;
  order?: string;
  reportId?: number;
  reportName?: string;
  hasNoAccess: string[];
  createTime: number;
  updatedAt?: number;
  overview?: string;
  action?: string;
  ipName?: string;
  dpType?: any;
  category?: string;
  createdAt?: Date;
}

export interface Cards {
  id: number;
  title: string;
  jobId?: number;
  value: string;
  comparedToValue?: string;
  growth?: number;
  growthType?: string;
  positiveState?: string;
  companyName?: string;
  reportVersionId: number;
  pinUserDashboard: string[];
  hasNoAccess: string[];
  createTime: number;
  overview?: string;
  cardIdentifier: string;
  order?: string;
  config?: any;
  reportId?: number;
  ipName?: string;
  reportName?: string;
  updatedAt?: number;
  channels?: any[];
  dpType?: any;
}

export interface DataSource {
  id: number;
  name: string;
}
export interface RootUser {
  id: number;
  name: string;
  email: string;
}
export interface User {
  id: number;
  name: string;
  companyId: number;
  companyName?: string;
  companyType?: string;
  role: UserRole;
  status: UserStatus;
  email: string;
  phoneNumber?: string;
  linkedInId?: string;
  employeeId?: string;
  designation?: string;
  department?: string;
  lastLoginTime?: string;
  referralCode?: string;
  color?: string;
  whatsappReport?: number;
  phoneCode?: string;
}
export type ExtendedUser = User & {
  inviteStatus: "SUCCESS" | "PENDING" | "FAILURE";
  category: string;
};

export enum UserRole {
  Admin = "Admin",
  User = "User",
  Agency = "Agency",
  // Executive = "Executive",
  // Analyst = "Analyst",
}
export enum SignUpRole {
  Brand = "brand",
  Agency = "agency",
}
export enum UserStatus {
  Active = "Active",
  Disabled = "Disabled",
}
export interface UserGroup {
  id: number;
  name: string;
  companyId: number;
  createTime: number;
  ownerUserId: number;
  color: string;
}

export interface UserFile {
  id: string;
  path: string;
  name: string;
  sheetNames: UserFileSheetName[];
  createTime: number;
}

export interface UserFileSheetName {
  index: number;
  name: string;
  isDataDump: boolean;
}

export function getDummyReport(): Report {
  return {
    id: 0,
    name: "New Report",
    createdByUserId: 1,
    status: ReportStatus.Draft,
    createTime: Date.now(),
    emailSubject: null,
    emailBody: null,
    workspaceId: null,
  };
}

export type selectedRecipientType = {
  id: number;
  recipientId?: number;
  name: string;
  profileImage?: string;
  role: string;
  designation: string;
  companyId?: number;
  color?: string;
  has_whatsapp_access: boolean;
  has_email_access: boolean;
};

export interface AccessUsers {
  id: number;
  name: string;
  companyId: number;
  email: string;
  role: string;
}

export interface Channel {
  id?: number | string;
  name: string;
  referenceId: number;
  reportId?: number;
  datapieceName?: string;
  reportName?: string;
  reportDate?: number;
  reportVersion: number;
  createdBy: number;
  createdByName?: string;
  channelType: number;
  createdAt?: number;
  updatedAt?: number;
  members: string[];
  nonMembers?: {
    [x: string]: number;
  };
  pin: string[];
  color?: string;
  versionDataPeriod?: DataPeriodType;
  versionTime?: number;
}

export interface Message {
  id: number;
  channelId: number;
  message: string;
  senderId: number;
  timestamp: number;
  files: string;
  deletedAt: number;
  editedAt: number;
  parentMessageId: number;
  isMessage: number;
  senderName?: string;
  replies?: {
    repliedMessageId: number;
    repliedToUserId: number;
    repliedMessage: string;
  };
}

export interface UnreadMessageCount {
  channelId: number;
  userId: number;
  unreadCount: number;
}

export interface Tracker {
  id: number;
  referenceId: number;
  trackerName: string;
  trackerType: number;
  trackerDate: number;
  createdBy: number;
  trackerRecipients: string[];
  reportId: number;
  reportVersion: number;
  trackerMessage?: string;
  status: TrackerStatus;
  createdAt?: number;
  updatedAt?: number;
}

export interface TrackerWithRecipientNames extends Tracker {
  createdByName?: string;
  recipientsNames?: string[];
  dateDiff?: number;
}

export enum TrackerStatus {
  Active = 0,
  Pending = 2,
  Done = 1,
}

export interface Notification {
  id: number;
  notificationType: number; //0-APP, 1-Browser 2-Email
  notificationEvent: number;
  sendTo: number;
  sendTime: number;
  notificationBody: any;
  referenceId: number;
  subReferenceId: number;
  referenceType: number; //0-chat 1-tracker 2-workspace(report)
  status: number; //0-Pending 1-Success/Send 2-Fail 3-Cancel
  createdBy: number;
  createdAt: number;
}

export interface Metrics {
  title: string;
  label: string;
  subLabel: string;
}

export interface SetMetrics {
  title: string;
  metricKey: string;
  isValue: boolean;
  isDatasetLabel: boolean;
  isSum: boolean;
  isLabel: boolean;
  childMetricKey?: string[];
  selectedMetric?: string;
}

export interface NewMetrics {
  title: string;
  metricKey: string;
  isValue: boolean;
  isDatasetLabel: boolean;
  sumMetricKey?: string;
  isLabel: boolean;
  parent: string;
  metrics?: NewMetrics[];
}

export interface SetMetrics {
  title: string;
  metricKey: string;
  isValue: boolean;
  isDatasetLabel: boolean;
  isSum: boolean;
  isLabel: boolean;
  childMetricKey?: string[];
}

export interface MetricsConditions {
  benchmarkValue: number;
  triggerCondition: {
    label: string;
    value: number;
  };
}

export type BreachedMetrics = {
  triggeredMetrics: Metrics;
  actualValue: number;
  triggerConditions: MetricsConditions[];
};

export interface DataAlert {
  id: number;
  name: string;
  referenceId: string;
  reportId: number;
  reportName?: string;
  reportVersionId: number;
  alertType: number;
  createdBy?: number;
  recipients: string[];
  recipientNames?: string[];
  // metrics: Metrics[];
  metrics: SetMetrics[];
  conditions: MetricsConditions[];
  conditionType: number;
  emailNotification: number;
  status?: number;
  createdAt?: number;
  updatedAt?: number;
  actionTaken?: string;
}

export interface ActiveAlerts {
  id: number;
  alertId: number;
  name?: string;
  referenceId?: string;
  recipients?: string[];
  reportId?: number;
  reportName?: string;
  reportVersionId: number;
  isActiveAlertPresent?: boolean;
  reportVersionTime?: number;
  breachedMetrics: BreachedMetrics[];
  status: number;
  createdAt: number;
  updatedAt: number;
}

export interface TriggeredAlertWithActiveAlert extends ActiveAlerts {
  name: DataAlert["name"];
  referenceId: DataAlert["referenceId"];
  recipients: DataAlert["recipients"];
  createdBy: DataAlert["createdBy"];
  reportId: DataAlert["reportId"];
  condition_type: DataAlert["conditionType"];
  triggered_count?: number;
}

export interface DataAlertByReport {
  id: number;
  name: string;
  reportName: string;
  reportId: number;
  triggeredCount?: number;
}

export interface TrackerSummary {
  activeTrackersCount: number;
  overdueTrackersCount: number;
  closedTrackersCount: number;
  lastMonthTrackers: TrackerWithRecipientNames[];
  topOverdueTrackers: TrackerWithRecipientNames[];
  topUpcomingTrackers: TrackerWithRecipientNames[];
}

export interface CommonError {
  field?: string;
  message: string;
}

export enum PinnedVisualType {
  card = "CARD",
  chart = "CHART",
  pivotTable = "TABLE",
  cohort = "COHORT",
  metric = "METRIC",
}

export type PinnedVisual = {
  id?: number;
  reportId: number;
  identifier: string;
  type: PinnedVisualType;
};

type PinnedVisualIdentifierData = {
  reportId: number;
  identifier: string;
};

export type PinnedVisualIdentifiersState = {
  charts: Set<string>;
  cards: Set<string>;
  pivotTables: Set<string>;
  cohorts: Set<string>;
};

export type PinnedVisualIdentifiers = {
  charts: PinnedVisualIdentifierData[];
  cards: PinnedVisualIdentifierData[];
  pivotTables: PinnedVisualIdentifierData[];
  cohorts: PinnedVisualIdentifierData[];
};

export type ReportDetailsData = {
  chart: Chart[];
  pivot: PivotTable[];
  report: Report;
  reportVersion: ReportVersion;
  user: any;
  createdUser: User;
};

export type DashboardDataPieces = {
  pinnedCharts: Chart[];
  charts: Chart[];
  pinnedPivotTables: PivotTable[];
  pivotTables: PivotTable[];
  pinnedCards: Cards[];
  pinnedCohorts: Cohort[];
  reportObj?: { [x: number]: Report };
};

export interface userWsLink {
  id?: number;
  userId: User["id"];
  favWs?: string[];
  authenticatedWs: string[];
}

export interface IIntegrationPartner {
  _id?: string;
  companyName: string;
  companyCode: string;
  name: string;
  email: string;
  password: string;
  contactNumber: string;
  profileImage: string;
  isVerified: boolean;
  logo: string;
  desc: string;
  combined?: boolean;
  mandatoryIp?: IIntegrationPartner[];
  optionalIp?: IIntegrationPartner[];
  nonMandatoryIp?: IIntegrationPartner[];
  optionalRequired?: Boolean;
  isSalesChannel?: boolean;
  authMethod?: string;
  noReplyEmail?: string;
}

export interface IPWorkspace {
  _id?: string;
  workspaceName: string;
  productName: string;
  metrics: {
    name: string;
    formula: string;
  }[];
  customerContext: {
    question: string;
    answer: string;
  }[];
  primaryPurpose: {
    question: string;
    answer: string;
  };
  dataSet: any;
  refreshInterval: string;
  refreshFrequency?: string;
  lastRefreshTime?: Date;
  userIds?: string[];
  integrationPartner: IIntegrationPartner;
  status?: string;
  shortDesc?: string;
  longDesc?: string;
  images?: string[];
  dataPeriod?: string;
  maxDataPeriod?: {
    [x: string]: number;
  };
}

export interface AccessTokens {
  id: number;
  userId: number;
  integrationPartner: string;
  accessTokens: string;
  updateAvailable: boolean;
}

export enum TrackerScreens {
  summary = "summary",
  active = "active",
  overdue = "overdue",
  completed = "completed",
}

export interface IpWorkspaceReportInfo {
  integrationPartnerName: string;
  refreshFrequency: string;
}

export interface isFirstLogin {
  userId: number;
  firstLogin: boolean;
}

export interface isVisited {
  userId: number;
  isVisited: boolean;
}

export interface ChildTriggeredMetrics extends MetricsConditions {
  actualValue: number;
  metricKey: string;
}

export type NewBreachedMetrics = {
  triggeredMetrics: SetMetrics;
  actualValue: number;
  dataAlertLabel: string;
  triggerConditions: MetricsConditions[];
  childTriggerConditions?: {
    [x: string]: ChildTriggeredMetrics[];
  };
};

export interface NewBreachedAlerts {
  breachedMetrics: NewBreachedMetrics[];
  alertId: number;
}

export interface NewActiveAlerts {
  id: number;
  alertId: number;
  name?: string;
  referenceId?: string;
  recipients?: string[];
  reportId?: number;
  reportName?: string;
  reportVersionId: number;
  isActiveAlertPresent?: boolean;
  reportVersionTime?: number;
  breachedMetrics: NewBreachedMetrics[];
  status: number;
  createdAt: number;
  updatedAt: number;
}

export type DataPeriodType = {
  type: number;
  value: number;
  days: string;
};

export enum DatapieceType {
  card = "CARDS",
  chart = "CHART",
  pivotTable = "TABLE",
  cohort = "COHORT",
}

export enum JobType {
  addWorkspace = 1,
  refreshWorkspace = 2,
  permanentDataPeriod = 3,
  temporaryDataPeriod = 4,
  pullData = 5,
  viewSelect = 6,
  refreshNow = 7,
  dsPortal = 8,
  workspaceComparison = 13,
  credentialVerification = 14,
  emailForwardConfirmation = 15,
}

export enum ToastifyStatus {
  success = "SUCCESS",
  failure = "FAILURE",
}

export enum presetTypes {
  thisWeek = "THIS_WEEK",
  thisMonth = "THIS_MONTH",
  thisQuarter = "THIS_QUARTER",
  last7Days = "LAST_7_DAYS",
  last30Days = "LAST_30_DAYS",
  last60Days = "LAST_60_DAYS",
  last90Days = "LAST_90_DAYS",
  Custom = "CUSTOM",
  customRange = "CUSTOM_RANGE",
  customRangeSingleDay = "CUSTOM_RANGE_SINGLE_DAY",
  last12Months = "LAST_12_Months",
  last6Months = "LAST_6_Months",
  last18Months = "LAST_18_Months",
  events = "EVENTS",
  previousWeek = "PREVIOUS_WEEK",
  previousMonth = "PREVIOUS_MONTH",
  previousYear = "PREVIOUS_YEAR",
}

export interface RangeType {
  value?: number;
  type?: number;
  // days: string;
  enumType: presetTypes;
  eventKey?: string;
  eventName?: string;
  matchDayOfWeek?: boolean;
}

export interface InitialRangeType extends RangeType {
  startDate?: Date;
  endDate?: Date;
}

export interface RangeConfig {
  customDataPeriod: InitialRangeType;
  compareToDataPeriod: InitialRangeType;
}

export enum DefaultCohortFilters {
  firstFilter = "%",
  otherFilter = "Overall",
}

export enum WorskpaceTitles {
  websiteSalesHub = "Website Sales Hub",
  websitePerformanceMarketing = "Website Performance Marketing",
  googleAdsPerformance = "Google Ads Performance",
  metaAdsPerformance = "Meta Ads Performance",
  discountCodeAnalysis = "Discount Code Analysis",
  cohortAnalysis = "Customer Cohort Analysis",
  consolidatedWorkspace = "Consolidated Sales Hub",
  amazonPerformanceMarketing = "Amazon Performance Marketing",
  amazonSalesHub = "Amazon Sales Hub",
}

export enum GADimensions {
  userType = "userType",
  companyId = "companyId",
  companyName = "dimension3",
  workspaceName = "reportName",
  userLoginId = "userLoginId",
  userId = "value",
  userName = "dimension9",
  datapieceName = "datapieceName",
  datapieceType = "datapieceType",
  datapieceIdentifier = "datapieceIdentifier",
  userTypeUL = "userTypeUL",
  userIdUL = "userIdUL",
  userNameUL = "userNameUL",
  companyIdUL = "companyIdUL",
  companyNameUL = "companyNameUL",
  decisionName = "decision_name",
  section_name = "section_name",
  insightId = "insightId",
  insightTemplateId = "insightTemplateId",
  metricId = "metricId",
  metricName = "metricName",
  debug = "_dbg",
  pnl_type = "pnl_type",
  dp_event_name = "dp_event_name",
  comparison_event_name = "comparison_event_name",
  dp_journey_start = "dp_journey_start",
}

export enum GAEvents {
  user_activity = "user_activity",
  idea_click = "idea_click",
  download_as_excel = "download_as_excel",
  add_workspace = "add_workspace",
  open_workspace = "open_workspace",
  pin_datapiece = "pin_datapiece",
  open_datapiece = "open_datapiece",
  open_decision = "open_decision",
  section_click = "sidebar_section_click",
  metric_selected = "metric_click",
  pnl_update = "pnl_update",
  custom_data_period_click = "custom_data_period_click",
  comparison_box_click = "comparison_box_click",
  comparison_toggle_click = "comparison_toggle_click",
  comparison_drop_off = "comparison_drop_off",
  custom_data_period_drop_off = "custom_data_period_drop_off",
  custom_data_period_job = "custom_data_period_job",
  comparison_job = "comparison_job",
  workspace_cards_expand = "workspace_cards_expand",
  workspace_cards_collapse = "workspace_cards_collapse",
  reports_without_comparison = "reports_without_comparison",
  reports_with_comparison = "reports_with_comparison",
  sfpl_banner_creditplan_click = "sfpl_banner_creditplan_click",
  sfpl_banner_consultation_click = "sfpl_banner_liveconsultation_click",
}

export enum WorkspaceCreationWith {
  NOTHING = "NOTHING",
  VIEW_SELECT = "VIEW_SELECT",
  DATA_PERIOD = "DATA_PERIOD",
}

export enum SocketEvents {
  getId = "getId",
  test = "test",
  progress = "progress",
}

export enum ProgressStage {
  stage_0 = "Fetching Data...",
  stage_1 = "Building Reports...",
  stage_2 = "Almost Done...",
  stage_3 = "Hold Tight. We are working on this...",
}

export enum ExpandViewFromScreens {
  workspace = "WORKSPACE",
  decisionHub = "DECISION_HUB",
  dashboard = "DASHBOARD",
}

export enum InsightVote {
  upvote = "UPVOTE",
  downvote = "DOWNVOTE",
}

export enum InsightViewFor {
  workspace = "WORKSPACE",
  cohort = "COHORT",
}

export enum MetricGrowthType {
  increase = "INCREASE",
  decrease = "DECREASE",
  neutral = "NEUTRAL",
}

export interface GoalValues {
  growth: { type: MetricGrowthType; value: number };
  currentMonth: { type: MetricGrowthType; value: number; unit: string };
  previousMonth: { type: MetricGrowthType; value: number; unit: string };
}

export enum GoalStatus {
  success = "SUCCESS",
}

export interface IdeaWithLinking {
  label: string;
  workspaceName: string;
  insightTemplateId: number;
  metricId: number;
  dpIdentifier: string;
  dpType: DatapieceType;
  dataPeriod: string;
  mandatoryIp: string[];
  optionalIp: string[];
  triggerStatuses: Record<string, string>;
  columnsToShow: string[];
  insightId: number;
  insights: { insight?: string; suggestion?: string };
  reportId: number;
  reportTitle: string;
  reportStatus: string;
  createdByUserId: number;
  reportVersionId: number;
  isWorkspaceAccess: boolean;
  datapieceId: number;
  disconnectedMandatoryIp: string[];
  disconnectedOptionalIp: string[];
  voteData: { id: number; vote: InsightVote; comments: string } | null;
  ipName: string;
  isNew: boolean;
}

export enum MetricPositiveState {
  increase = "INCREASE",
  decrease = "DECREASE",
}

export interface GoalsHubResponse {
  data: GoalsAndIdeas[];
  coldState: ColdStateType;
}

export interface GoalsAndIdeas {
  showOnFE: any;
  id: number;
  title: string;
  category: string;
  mandatoryIp: string[];
  optionalIp: string[];
  values: GoalValues;
  dataSource: string[];
  companyId: number;
  createdAt: Date;
  currentDataPeriod: [string, string];
  previousDataPeriod: [string, string];
  order: number;
  status: GoalStatus;
  positiveState: MetricPositiveState;
  ideas: IdeaWithLinking[];
  isRefreshed: boolean;
  isInProgress: boolean;

  // For UI
  tooltip: string;

  lastRefreshed?: string;
  currentDataPeriodObj?: [Moment, Moment];
  previousDataPeriodObj?: [Moment, Moment];
  disconnectedMandatoryIp: string[];
  disconnectedOptionalIp: string[];
  ideasDisconnectedIp: string[];
}

export interface ISelectedDatapieceParams {
  datapieceId: number[] | number;
  datapieceType: DatapieceType;
  reportId: number;
  reportVersionId: number;
  workspaceName: WorskpaceTitles;
  ipName: string;

  // For insight feed
  selectedInsightId: number;
  dpIdentifier: string;
  reportTitle: string;
}

export enum InsightTypes {
  ideas = "IDEAS",
  moves = "MOVES",
  movesTrendingUp = "MOVES_TRENDING_UP",
  movesTrendingDown = "MOVES_TRENDING_DOWN",
}

export interface InsightPost {
  columnsToShow: [];
  createdAt: string;
  createdByUserId: number | null;
  dataSource: string[];
  datapieceId: number | null;
  datapieceLinkingId: number | null;
  datapieceLinkingOrder: number | null;
  disconnectedMandatoryIp: [];
  disconnectedOptionalIp: [];
  dpIdentifier: string | null;
  insightId: number;
  insightTemplateId: number;
  insightType: InsightTypes;
  insights: { insight?: string; suggestion?: string; tagline?: string };
  isWorkspaceAccess: boolean;
  label: string;
  mandatoryIp: [];
  metricName: string | null;
  optionalIp: [];
  reportId: number | null;
  reportStatus: ReportStatus | null;
  reportTitle: string | null;
  reportVersionId: number | null;
  voteData: { id: number; vote: InsightVote; comments: string } | null;
  workspaceName: string | null;
  ipName: string;
  dpType: DatapieceType;
  positiveState?: "INCREASE" | "DECREASE";
  // For UI
  createdAtObj: Moment;
  error?: string;
}

export interface VoteState {
  vote?: InsightVote;
  comment?: string;
  commentPending?: boolean;
}

export enum InsightFeedFor {
  expandedView = "EXPANDED_VIEW",
  goalsHub = "GOALS_HUB",
}

export enum LoadingProgressType {
  dataFetching = "DATA_FETCHING",
  insightGeneration = "INSIGHT_GENERATION",
  deleteDataFs = "DELETE_DATA_FS",
  deleteDataInsight = "DELETE_DATA_INSIGHT",
  fetchingProductCostDf = "FETCHING_PRODUCT_COST_DF",
  fetcingProductCostIg = "FETCHING_PRODUCT_COST_IG",
  fetchingProductCostFs = "FETCHING_PRODUCT_COST_FS",
  dataFetchingPrd = "DATA_FETCHING_PRD",
}

export enum IpNames {
  shopify = "Shopify",
  amazonSellerCentral = "Amazon Seller Central",
  googleAds = "Google Ads",
  metaAds = "Meta Ads",
  googleAnalytics = "Google Analytics",
  amazonAds = "Amazon Ads",
  amazonVendorCentral = "Amazon Vendor Central",
  flipkartAds = "Flipkart Ads",
  zepto = "Zepto",
  myntra = "Myntra",
  blinkitB2b = "Blinkit B2B",
  swiggyInstamart = "Swiggy Instamart",
  blinkitMarketplace = "Blinkit Marketplace",
  flipkartSeller = "Flipkart Seller",
  nykaa = "Nykaa",
  blinkitAds = "Blinkit Ads",
}

export enum financeTabNames {
  sales = "Sales Channels",
  expenses = "Expenses",
  productCosts = "Product Costs",
  fulfilmentCosts = "Fulfilment Costs",
  marketingCosts = "Marketing Costs",
}

export enum formActionTypes {
  add = "ADD",
  edit = "EDIT",
  delete = "DELETE",
}

export enum TypeOfAmount {
  fixed = "fixed",
  percentage = "percentage",
}

export enum TypeOfFinanceOption {
  financeStatement = "statement",
  financeMetric = "metric",
}

export enum MetricValueType {
  updatedCost = "updated_cost",
  apiCost = "api_cost",
}

export interface ProductCostsFilter {
  searchString: string;
  integrationPartner: string;
  onlyMissingCosts: boolean;
}

export enum FinanceStatementColdState {
  statementInProgress = "STATEMENT_IN_PROGRESS",
}

export enum featureType {
  profitabilityCalculator = "profitability_calculator",
}

export enum PcSectionSteps {
  updateShopify = "Update Shopify",
  addSalesChannels = "Sales Channels",
  addProductCosts = "Product Costs",
  addExpenses = "Direct Expenses",
  connectShopify = "Connect Shopify",
  editAccess = "Edit Access",
  otherExpenses = "Other Expenses",
}

export enum PcColdStates {
  connectSalesChannel = "CONNECT_SALES_CHANNELS",
  salesChannelDataFetching = "SALES_CHANNEL_DATA_FETCHING",
  accessDenied = "ACCESS_DENIED",
  journeyInProgress = "JOURNEY_IN_PROGRESS",
}
export enum PcJourneyStatus {
  inProgress = "in_progress",
  completed = "completed",
}

export enum pnlFormat {
  thousands = "THOUSANDS",
  lakhs = "LAKHS",
}

export enum PnlCategoryNames {
  salesChannels = "Sales Channels",
  shippingCost = "Shipping Cost",
  packagingCost = "Packaging Cost",
  taxes = "Taxes",
  additionalCost = "Other Direct Cost",
  platformCommision = "Platform Commission",
  adSpends = "Ad Spends",
  productCosts = "Product Costs",
  otherExpenses = "Other Expenses",
}

export enum ProductFetchingProgress {
  inProgress = "IN_PROGRESS",
  success = "SUCCESS",
  failed = "FAILURE",
}

export enum TaxTypes {
  notApplicable = "NOT_APPLICABLE",
  fixed = "FIXED",
  variable = "VARIABLE",
}

export interface TaxInputInf {
  id?: number;
  companyId: number;
  taxType: TaxTypes;
  value?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum PnlFsNames {
  sales = "Sales",
  gstCollected = "GST Collected",
  cogs = "Cost of Goods Sold",
  otherIncome = "Other Income",
  netSales = "Net Sales",
  percGrowth = "Monthly Growth %",
  grossProfit = "Gross Profit",
  grossProfitPerc = "Gross Profit %",
  cm1 = "CM1",
  cm2 = "CM2",
  cm1Perc = "CM1 %",
  cm2Perc = "CM2 %",
  platformCommission = "Platform Commission",
  shippingCost = "Shipping Cost",
  packagingCost = "Packaging Cost",
  adSpend = "Ad Spend",
  operatingExpenses = "Operating Expenses",
  ebitda = "EBITDA",
  ebitdaMargin = "EBITDA Margin",
  loanServicing = "Loan Servicing",
  netCash = "Net Cash",
  netCashMargin = "Net Cash Margin",
}

export enum PnlFsMetricNames {
  amazonAds = "Amazon Ads",
}

export enum InstallmentType {
  fixed = "FIXED",
  variable = "VARIABLE",
}

export enum underwritingRoutes {
  underwritingHome = "/underwriting",
  underwritingApplication = "/underwriting/application",
  underwritingAccounts = "/underwriting/application/accounts",
  underwritingCompany = "/underwriting/application/company-details",
  underwritingRevenue = "/underwriting/application/revenue-details",
  underwritingKeyEvents = "/underwriting/application/key-events",
  underwritingInvestments = "/underwriting/application/investments",
  underwritingDocuments = "/underwriting/application/upload-documents",
  underwritingPnl = "/underwriting/application/pnl",
  underwritingStatus = "/underwriting/status",
  underwritingDirector = "/underwriting/application/director-details",
  underwritingChecklist = "/underwriting/application/checklist",
}

export enum monthlyReportRoutes {
  monthlyReportHome = "/monthlyReport",
  monthlyReportApplication = "/monthlyReport/application",
  connectAccounts = "/monthlyReport/application/connect-accounts",
  bankStatement = "/monthlyReport/application/bank-statement",
  salesMarketing = "/monthlyReport/application/sales-marketing",
  businessUpdates = "/monthlyReport/application/business-updates",
  gst = "/monthlyReport/application/gst",
  recipients = "/monthlyReport/application/recipients",
  checklist = "/monthlyReport/application/checklist",
}

export enum UnderwritingSteps {
  accounts = "CONNECT_ACCOUNTS",
  company = "COMPANY",
  revenue = "REVENUE",
  keyEvents = "KEY_EVENTS",
  investments = "INVESTMENTS",
  documents = "UPLOAD_DOCUMENTS",
  director = "DIRECTOR",
  pnl = "PNL",
}

export enum UnderWritingStepsTitle {
  accounts = "Connect Accounts",
  company = "Company",
  revenue = "Finance",
  keyEvents = "Key Events",
  investments = "Investments",
  documents = "Bank Statement",
  director = "Director",
  pnl = "P&L",
}

export enum validationErrorTypes {
  required = "REQUIRED",
  invalid = "INVALID",
}

export enum idProofs {
  aadharCard = "AADHAR_CARD",
  panCard = "PAN_CARD",
  drivingLicense = "DRIVING_LICENSE",
}

export enum investorType {
  angel = "ANGEL",
  vc = "VENTURE_CAPITAL",
  accelerator = "ACCELERATOR",
}

export enum keyEventType {
  event = "event",
  festival = "festival",
}

export enum UnderwritingFormStatus {
  COMPLETED = "COMPLETED",
  INCOMPLETE = "INCOMPLETE",
}

export enum LendingStatus {
  IN_PROGRESS = "IN_PROGRESS",
  PENDING_APPROVAL = "PENDING_APPROVAL",
  COMPLETED = "COMPLETED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
}

export enum UnderwritingColdState {
  accessDenied = "ACCESS_DENIED",
  inProgress = "IN_PROGRESS",
  pendingState = "PENDING_STATUS",
  completed = "COMPLETED",
}

export enum LinkType {
  underwriting = "UNDERWRITING",
  disbursement = "DISBURSEMENT",
  monthlyReport = "MONTHLY_REPORT",
}

export enum LendingJobType {
  underwriting = "UNDERWRITING",
  disbursement = "DISBURSEMENT",
  monthlyReport = "MONTHLY_REPORT",
}

export enum disbursementRoutes {
  disbursementSections = "/disbursement",
  disbursementVerifySupplier = "verify-supplier",
  disbursementInvoiceProducts = "invoice-products",
  disbursementSuccess = "status/success",
  disbursementExpired = "status/expired",
  disbursementStatus = "status/:status",
}

export enum DisbursementFormSteps {
  START_MESSAGE = "START_MESSAGE",
  UPLOAD_INVOICE = "UPLOAD_INVOICE",
  ENTER_INVOICE_DETAILS = "ENTER_INVOICE_DETAILS",
  UPLOAD_PTR = "UPLOAD_PTR",
  VERIFY_SUPPLIER = "VERIFY_SUPPLIER",
  INVOICE_PRODUCTS = "INVOICE_PRODUCTS",
}

export enum DisbursementFormStepsTitle {
  VERIFY_SUPPLIER = "Verify Supplier",
  INVOICE_PRODUCTS = "Add Invoice Products",
}

export enum DisbursementColdState {
  accessDenied = "ACCESS_DENIED",
  linkExpired = "LINK_EXPIRED",
}

export enum alignmentType {
  leftAlign = "leftAlign",
  centerAlign = "centerAlign",
  rightAlign = "rightAlign",
}

export enum uploadStates {
  requiredPassword = "REQUIRED_PASSWORD",
  passwordValidated = "PASSWORD_VALIDATED",
  uploading = "UPLOADING",
  doneUploading = "UPLOADED",
}

export interface missingCostItemsInf {
  items: any;
  missingCounts: number;
  lastMonth: string;
  missingSections;
}

export interface missingProductCostsInf {
  productCount: number;
  missingCostCount: number;
  status: "FETCHING" | "COMPLETED";
}

export enum DataPeriodScreenType {
  workspace = "WORKSPACE",
  dashboard = "DASHBOARD",
}

export enum dataPeriodJobStates {
  dataFetchingInProgress = "DATA_FETCHING_IN_PROGRESS",
  success = "SUCCESS",
  inProgress = "IN_PROGRESS",
  insufficientConnections = "INSUFFICIENT_CONNECTIONS",
  failure = "FAILURE",
}

export enum ShimmerColors {
  from = "#f6f6f9",
  via = "#e5e4ec",
  to = "#f6f6f9",
}

export enum dashboardJobSetType {
  metrics = "METRICS",
  datapieces = "DATAPIECES",
}

export enum dashboardColdStates {
  salesAccountNotConnected = "SALES_ACCOUNT_NOT_CONNECTED",
}

export enum CalendarType {
  customDatePeriod = "CUSTOM_DATE_PERIOD",
  compareToDatePeriod = "COMPARE_TO_DATE_PERIOD",
}

export enum ConnectionHubFromScreen {
  underwriting = "UNDERWRITING",
}

export enum StatementStepType {
  pdf_upload = "PDF_UPLOAD",
  net_banking = "NET_BANKING",
}

export const rpaTypes: string[] = ["password"];

export enum pdfProtectionStates {
  passwordRequired = "PASSWORD_REQUIRED",
  passwordValidated = "PASSWORD_VALIDATED",
  passwordValidationFailed = "PASSWORD_VALIDATION_FAILED",
  errorProcessing = "ERROR_PROCESSING",
  passwordNotRequired = "PASSWORD_NOT_REQUIRED",
}

export enum StatementAnalysisStatus {
  processing = "PROCESSING",
  verifying = "VERIFYING",
  verificationSuccess = "VERIFICATION_SUCCESS",
  failure = "FAILURE",
  requestTimedOut = "REQUEST_TIMED_OUT",
  errorOverrided = "ERROR_OVERRIDED",
}

export enum GstAnalysisStatus {
  inProgress = "IN_PROGRESS",
  success = "SUCCESS",
  failure = "FAILURE",
}

/** financial_statement_jobs.status via GET /smartfin/classificationResult */
export enum FinancialStatementClassificationStatus {
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
  FAILURE = "FAILURE",
}

export enum StatementAnalysisErrorTypes {
  BALANCE_RECONCILIATION_FAILED = "Balance Reconciliation Failed",
  EOD_MISSING_RANGES = "Missing EOD Balance Ranges",
}

export enum BankStatementWarningType {
  missingTransactions = "MISSING_TRANSACTIONS",
  uploadedAllStatement = "UPLOADED_ALL_STATEMENT",
}

export enum underwritingFormWarningType {
  save = "SAVE",
  cancel = "CANCEL",
}

export enum integrationAuthFormFields {
  email = "email",
  password = "password",
  emailClient = "email_client",
  otpOption = "otp_option",
}

export enum OtpDeliveryOptions {
  NoOtp = "No OTP",
  Email = "OTP on Email",
  Mobile = "OTP only on Mobile",
}

export enum forwardEmailQueueStatus {
  inProgress = "IN_PROGRESS",
  success = "SUCCESS",
  failure = "FAILURE",
}

export enum AuthMethods {
  OAuth = "oauth",
  password = "password",
  email_otp = "email_otp",
  OTP = "otp",
  magicLink = "magic_link",
  email_otp_password = "email_otp_password",
}

export const rpaAuthTypes = new Set([
  AuthMethods.password,
  AuthMethods.email_otp,
  AuthMethods.email_otp_password,
  AuthMethods.OTP,
  AuthMethods.magicLink,
]);

export enum ipEmailClients {
  gmail = "gmail",
  outlook = "outlook",
  others = "others",
}

export const PENDING_CREDENTIAL_CONFIRMATION_IPS: ReadonlySet<IpNames> =
  new Set([
    IpNames.blinkitB2b,
    IpNames.nykaa,
    IpNames.myntra,
    IpNames.blinkitMarketplace,
  ]);

export enum earlyAccessIpAuthType {
  password = "password",
  emailOtp = "email_otp",
  phoneOtp = "phone_otp",
}

export enum earlyAccessDetailsStatus {
  success = "SUCCESS",
  otpPending = "OTP_CONFIRMATION_PENDING",
}

export interface DrawerStateInf {
  isOpen: boolean;
  cardDetails: Cards;
}

export enum SalesFieldType {
  mrp = "MRP",
  sales = "SALES",
}

export enum EmailOtpSteps {
  otpInstructions = 0,
  credential = 1,
  checkForwardingAlreadySet = 12,
  multiOtpSelection = 10,
  emailForwardValidation = 4,
  emailForwardGif1 = 2,
  emailForwardGif2 = 3,
  outlookFilterGif1 = 4,
  gmailFilterGif1 = 5,
  gmailFilterGif2 = 6,
  emailForwardUserConfirmation = 7,
  contactMeritoMobileOtp = 11,
}

export enum ConnectionHubErrorTypes {
  invalidCredentials = "Invalid Credentials",
  technicalError = "Technical Error",
}
export enum SalesMarketingSectionTypes {
  sales = "Net Sales",
  ads = "Ad Spends",
}

export enum MonthlyReportSteps {
  connectAccounts = "CONNECT_ACCOUNTS",
  bankStatement = "BANK_STATEMENT",
  salesMarketing = "SALES_MARKETING",
  businessUpdates = "BUSINESS_UPDATES",
  gst = "GST",
  recipients = "RECIPIENTS",
}

export enum MonthlyReportStepsTitle {
  connectAccounts = "Connect Accounts",
  bankStatement = "Bank Statements",
  salesMarketing = "Sales & Marketing",
  businessUpdates = "Business Updates",
  gst = "GST",
  recipients = "Recipients",
}

export enum ApplicationContextType {
  underwriting = "UNDERWRITING",
  monthlyReport = "MONTHLY_REPORT",
}

export enum FieldMode {
  edit = "EDIT",
  view = "VIEW",
}

export enum loanType {
  termLoan = "Term Loan",
  wcdl = "WCDL",
  cc = "CC",
  others = "Others",
}
